import React, { Component, useContext, useState } from "react";
import GettingStartedContext from "../utils/GettingStartedContext";
const link = $("#root").data("link");

const FormSection = () => {
    const {
        data,
        getProperty,
        langString,
        getLink,
        lang,
        ownership,
        plan,
        plane,
        hours,
        location,
        submittedQuestions,
    } = useContext(GettingStartedContext);

    const [processing, setProcessing] = useState(false);
    const [showForm, setShowForm] = useState(true);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();

        if (processing) {
            return;
        }

        setProcessing(true);

        const answers = [];
        for (const aQ of submittedQuestions) {
            if (aQ.ClassName === LOCATION_Q_CLASS) {
                answers.push({
                    Class: aQ.ClassName,
                    Question: {
                        Description: aQ.Description,
                    },
                    Option: location,
                });
            } else {
                answers.push({
                    Class: aQ.ClassName,
                    Option: {
                        ID: aQ.Option.ID,
                        ClassName: aQ.Option.ClassName,
                        Code: aQ.Option.Code,
                        Title: aQ.Option.Title,
                    },
                });
            }
        }

        // Pardot Client Side Submission
        fetch(
            `https://www2.airsprint.com/l/95002/2024-03-13/7v21th?FirstName=${firstName}&LastName=${lastName}&Phone=${phone}&Email=${email}`,
            {
                method: "GET",
            }
        ).then((response) => response.json());

        fetch(getLink("submit"), {
            method: "POST",
            body: JSON.stringify({
                plane: { ID: plane },
                answers: answers,
                plane: { ID: plane },
                formData: {
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                    phone: phone,
                },
                language: lang,
                filters:
                    submittedQuestions.length === 0
                        ? {
                              ownership: ownership,
                              plan: plan,
                              location: location,
                          }
                        : null,
            }),
        })
            .then((response) => response.json())
            .then((json) => {
                if (json.Response === "success") {
                    setShowForm(false);
                }
                setProcessing(true);
            });

        return false;
    };

    if (!showForm) {
        return (
            <div className="gsa__complete-form">
                <div className="grid-container grid-container--gsa">
                    <div className="grid-x gsa__complete-form__border">
                        <div className="small-12">
                            <div className="grid-x">
                                <div className="small-12 xlmedium-6">
                                    <h2>{getProperty(data, "ThankYou")}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="gsa__complete-form">
            <div className="grid-container grid-container--gsa">
                <div className="grid-x gsa__complete-form__border">
                    <div className="small-12">
                        <div className="grid-x">
                            <div className="small-12 xlmedium-6">
                                <h2>{getProperty(data, "FormTitle")}</h2>
                                <p>{getProperty(data, "FormDescription")}</p>
                            </div>
                            <div className="small-12 xlmedium-6">
                                <form onSubmit={handleSubmit}>
                                    <div className="field">
                                        <input
                                            type="text"
                                            name="firstName"
                                            placeholder={getProperty(
                                                data,
                                                "FirstNameHolder"
                                            )}
                                            value={firstName}
                                            onChange={(e) => {
                                                setFirstName(e.target.value);
                                            }}
                                            required
                                        />
                                    </div>
                                    <div className="field">
                                        <input
                                            type="text"
                                            name="lastName"
                                            placeholder={getProperty(
                                                data,
                                                "LastNameHolder"
                                            )}
                                            value={lastName}
                                            onChange={(e) => {
                                                setLastName(e.target.value);
                                            }}
                                            required
                                        />
                                    </div>
                                    <div className="field">
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder={getProperty(
                                                data,
                                                "EmailHolder"
                                            )}
                                            value={email}
                                            onChange={(e) => {
                                                setEmail(e.target.value);
                                            }}
                                            required
                                        />
                                    </div>
                                    <div className="field">
                                        <input
                                            type="text"
                                            name="phone"
                                            placeholder={getProperty(
                                                data,
                                                "PhoneHolder"
                                            )}
                                            value={phone}
                                            onChange={(e) => {
                                                setPhone(e.target.value);
                                            }}
                                            required
                                        />
                                    </div>
                                    <div className="action">
                                        <button
                                            style={{ pointerEvents: "all" }}
                                            className="button secondary"
                                        >
                                            {getProperty(data, "Submit")}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormSection;

// class FormSectionss extends Component {
//
//     constructor(props) {
//         super(props);
//         this.state = {
//             firstName: '',
//             lastName: '',
//             email: '',
//             phone: '',
//             showForm: true,
//             showError: false
//         };
//
//         this.handleChange = this.handleChange.bind(this);
//         this.handleSubmit = this.handleSubmit.bind(this);
//     }
//
//     // checkProperty(object, property) {
//     //
//     //     try {
//     //
//     //         const value = object[property];
//     //         return value;
//     //
//     //     }
//     //
//     //     catch (RuntimeBinderException) {
//     //
//     //         return '';
//     //
//     //     }
//     //
//     // }
//
//     // handleChange(event) {
//     //
//     //     const name = event.target.name;
//     //     let val = event.target.value;
//     //     this.setState({ [name]: val } , () => {  this.props.submitForm(this.state) });
//     // }
//
//     handleSubmit(event) {
//
//         this.addPointerStyle('none');
//         event.preventDefault();
//         let props = this.props;
//         const $this = this;
//         if (this.state.showError) {
//
//             return;
//
//         }
//         $.ajax({
//             url: link+'submit',
//             type: 'POST',
//             data: {
//                 answers: props.submittedQuestions,
//                 language: props.content.Language,
//                 formData: props.submittedForm,
//                 plane: props.submittedQuestions.length > 0 ? props.result.data.BestPlane : props.result.data.Plane,
//                 filters: props.manuallySelectedOptions,
//             },
//             dataType: 'JSON',
//             cache: true,
//         }).then(function(res) {
//
//             if (res.Response == 'success') {
//
//                 $this.setState({ showForm: false });
//
//             } else {
//
//                 $this.setState({ showForm: true }, () => {
//                     $this.addPointerStyle('all');
//                 })
//
//             }
//             const formData = {
//                 answers: props.submittedQuestions,
//                 formData: props.submittedForm,
//                 plane: props.submittedQuestions.length > 0 ? props.result.data.BestPlane : props.result.data.Plane,
//                 filters: props.manuallySelectedOptions,
//             };
//
//         });
//
//     }
//
//     addPointerStyle(value) {
//
//         return { pointerEvents: value };
//
//     }
//
//     render() {
//
//
//         if (!this.state.showForm) {
//
//             return (
//                 <div className="gsa__complete-form">
//                     <div className="grid-container grid-container--gsa">
//                         <div className="grid-x gsa__complete-form__border">
//                             <div className="small-12">
//                                 <div className="grid-x">
//                                     <div className="small-12 xlmedium-5">
//                                         <h2>{ this.checkProperty(this.props.content, 'ThankYou') }</h2>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             );
//
//         }
//
//         if (this.props.result.show) {
//             return (
//                 <div className="gsa__complete-form">
//                     <div className="grid-container grid-container--gsa">
//                         <div className="grid-x gsa__complete-form__border">
//                             <div className="small-12">
//                                 <div className="grid-x">
//                                     <div className="small-12 xlmedium-5">
//                                         <h2>{ this.checkProperty(this.props.content, 'FormTitle') }</h2>
//                                         <p>{ this.checkProperty(this.props.content, 'FormDescription') }</p>
//                                     </div>
//                                     <div className="small-12 xlmedium-6 xlmedium-offset-1">
//                                         <form onSubmit={this.handleSubmit}>
//                                             <div className="field">
//                                                 <input type="text"
//                                                        name="firstName"
//                                                        placeholder={ this.checkProperty(this.props.content,
//                                                            'FirstNameHolder') }
//                                                        value={this.state.firstName}
//                                                        onChange={this.handleChange} required/>
//                                             </div>
//                                             <div className="field">
//                                                 <input type="text"
//                                                        name="lastName"
//                                                        placeholder={ this.checkProperty(this.props.content,
//                                                            'LastNameHolder') }
//                                                        value={this.state.lastName}
//                                                        onChange={this.handleChange} required/>
//                                             </div>
//                                             <div className="field">
//                                                 <input type="email"
//                                                        name="email"
//                                                        placeholder={ this.checkProperty(this.props.content,
//                                                            'EmailHolder') }
//                                                        value={this.state.email}
//                                                        onChange={this.handleChange} required/>
//                                             </div>
//                                             <div className="field">
//                                                 <input type="text"
//                                                        name="phone"
//                                                        placeholder={ this.checkProperty(this.props.content,
//                                                            'PhoneHolder') }
//                                                        value={this.state.phone}
//                                                        onChange={this.handleChange} required/>
//                                                 {/*{ this.state.showError*/}
//                                                 {/*?   <span style={{color: '#d25d5d'}}>*/}
//                                                 {/*{ this.checkProperty(this.props.result.data, 'PhoneError') }*/}
//                                                 {/*</span>*/}
//                                                 {/*:   '' }*/}
//                                             </div>
//                                             <div className="action">
//                                                 <button style={this.addPointerStyle('all')} className="button secondary">
//                                                     { this.checkProperty(this.props.content,
//                                                         'Submit') }
//                                                 </button>
//                                             </div>
//                                         </form>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//
//             );
//
//         }
//
//         return('');
//
//     }
//
// }
//
// // function mapStateToProps(state) {
// //
// //     return {
// //         content: state.started,
// //         result: state.result,
// //         submittedQuestions: state.submittedQuestions,
// //         submittedForm: state.submittedForm,
// //         manuallySelectedOptions: state.manuallySelectedOptions,
// //     };
// //
// // }
// //
// // function matchDispatchToProps(dispatch){
// //
// //     return bindActionCreators({
// //         submitForm: submitForm,
// //     }, dispatch);
// //
// // }
// //
// // export default connect(mapStateToProps, matchDispatchToProps)(FormSection);
